// extracted by css-extract-rspack-plugin
export default {"HeaderText":"spLYv","HeaderTextCentered":"D1h07","HeaderTextContent":"tZPDi","HeaderTextContainer":"wfdjo","clickable":"X0Uln","actionIcon":"KlQXP","backButton":"RfrM_"};